import { Drawer, Box, Typography, Stack, Switch, FormControlLabel, Divider, IconButton, TextField, InputAdornment } from '@mui/material';
import Iconify from '../../../components/iconify';

export default function WorkspaceSettingsDrawer({ open, onClose, settings = {}, onUpdateSettings }) {
  const handleToggle = (key) => (e) => {
    onUpdateSettings({ ...settings, [key]: e.target.checked });
  };

  const handleNumber = (key) => (e) => {
    const val = parseInt(e.target.value, 10);
    onUpdateSettings({ ...settings, [key]: Number.isNaN(val) || val < 0 ? 0 : val });
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width: 320, p: 2 } }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
        <Typography variant="h6">Workspace Settings</Typography>
        <IconButton onClick={onClose} size="small">
          <Iconify icon="eva:close-fill" width={20} />
        </IconButton>
      </Stack>

      <Divider sx={{ mb: 2 }} />

      <Typography variant="subtitle2" sx={{ mb: 1 }}>Playback</Typography>

      <FormControlLabel
        control={
          <Switch
            checked={settings.skipEmptyTime || false}
            onChange={handleToggle('skipEmptyTime')}
          />
        }
        label={
          <Box>
            <Typography variant="body2">Skip Empty Time</Typography>
            <Typography variant="caption" color="text.secondary">
              Automatically jump over gaps between recordings during playback
            </Typography>
          </Box>
        }
        sx={{ alignItems: 'flex-start', ml: 0, mb: 2, '& .MuiFormControlLabel-label': { ml: 1 } }}
      />

      <FormControlLabel
        control={
          <Switch
            checked={settings.highlightReelMode || false}
            onChange={handleToggle('highlightReelMode')}
          />
        }
        label={
          <Box>
            <Typography variant="body2">Highlight Reel</Typography>
            <Typography variant="caption" color="text.secondary">
              During playback, automatically skip to the next rule event. Plays through each event, then jumps to the next one.
            </Typography>
          </Box>
        }
        sx={{ alignItems: 'flex-start', ml: 0, mb: 2, '& .MuiFormControlLabel-label': { ml: 1 } }}
      />

      {settings.highlightReelMode && (
        <TextField
          size="small"
          type="number"
          label="Highlight Reel Lag Time"
          helperText="Seconds of lead-in before each event"
          value={settings.highlightReelLag ?? 5}
          onChange={handleNumber('highlightReelLag')}
          InputProps={{
            endAdornment: <InputAdornment position="end">sec</InputAdornment>,
            inputProps: { min: 0, max: 60, step: 1 },
          }}
          sx={{ ml: 4, width: 180 }}
        />
      )}
    </Drawer>
  );
}
